import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  GcIconComponent,
  GcIconName,
  GcTextComponent,
} from '@ip-only/front-end-library';

@Component({
  selector: 'app-side-menu-button',
  imports: [GcTextComponent, GcIconComponent, RouterModule],
  templateUrl: './side-menu-button.component.html',
  styleUrl: './side-menu-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideMenuButtonComponent {
  icon = input.required<GcIconName>();
  label = input.required<string>();
  url = input.required<string>();
}
